// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 4:38 PM
 */
import {connect} from "react-redux";
import type {Caller, QueryPageDispatchProps, QueryPageOwnProps, QueryPageStateProps} from "../components/QueryPage";
import QueryPage from "../components/QueryPage";
import type {EBadgeQuerySuccessAction, EBadgeQueryThunkAction} from "../actions/ebadge/eBadgeQueryAction";
import {eBadgeQueryAction, eBadgeQuerySuccessAction} from "../actions/ebadge/creators/eBadgeQueryActionCreator";
import type {StoreState} from "../reducers/combinedReducers";
import {eBadgeUnlockAction} from "../actions/ebadge/creators/eBadgeUnlockActionCreator";
import type {EBadgeUnlockThunkAction} from "../actions/ebadge/eBadgeUnlockAction";
import {ssoUserQueryAction, ssoUserQuerySuccessAction} from "../actions/sso/creators/ssoUserQueryActionCreator";
import type {SsoUserQuerySuccessAction, SsoUserQueryThunkAction} from "../actions/sso/ssoUserQueryAction";
import type {EBadgeQueryCriteria, SortDirection, SortOption} from "../model/ebadge/EBadgeQueryCriteria";
import type {SsoUserQueryCriteria} from "../model/sso/SsoUserQueryCriteria";
import * as queryString from "query-string";
import * as _ from 'lodash';
import {reset, change} from 'redux-form';

type Dispatch = (EBadgeQueryThunkAction | EBadgeUnlockThunkAction | SsoUserQueryThunkAction | SsoUserQuerySuccessAction | EBadgeQuerySuccessAction | { type: string }) => any

export function extractCaller(state: StoreState): Caller {
    return {
        operator: state.loginUser.userId,
        comment: _.get(state, "profile.name", ""),
        language: "EN"
    };
}

const mapStateToProps = (state: StoreState, ownProps: QueryPageOwnProps): QueryPageStateProps => {
    return {
        ...state.eBadgeQuery,
        ...state.ssoUserQuery,
        eBadgeTotalResultCount: state.eBadgeQuery.totalResult,
        ssoUserTotalResultCount: state.ssoUserQuery.totalResult,
        eBadgeError: state.eBadgeQuery.error,
        ssoUserError: state.ssoUserQuery.error,
        eBadgeWarning: state.eBadgeQuery.warning,
        isEBadgesLoading: state.eBadgeQuery.isLoading,
        isSsoUsersLoading: state.ssoUserQuery.isLoading,
        fairConfigs: state.fairConfigs.list,
        fairConfigsByProjectCode: state.fairConfigs.configByProjectCode,
        countries: state.countries,
        generatePageLink: (page: number) => {
            let query = queryString.parse(ownProps.location.search);
            query.page = page;
            return {
                pathname: ownProps.location.pathname,
                search: `?${queryString.stringify(query)}`
            }
        },
        generateSortLink: (sort: SortOption, direction: SortDirection) => {

            let query = queryString.parse(ownProps.location.search);
            query.sort = sort;
            query.direction = direction;
            query.page = 1;
            return {
                pathname: ownProps.location.pathname,
                search: `?${queryString.stringify(query)}`
            }
        },
        currentSort: queryString.parse(ownProps.location.search).sort,
        currentSortDirection: queryString.parse(ownProps.location.search).direction,
        caller: extractCaller(state)
    };
};

const mapDispatchToProps = (dispatch: Dispatch): QueryPageDispatchProps => {
    return {
        onSearchCriteriaChanged: (search: string, caller: Caller) => {

            const object = Object.assign({
                    page: 1,
                    pageItem: 20
                },
                queryString.parse(search));
            const omitIfEmpty = (o) => !("" + o);
            const criteria: EBadgeQueryCriteria & SsoUserQueryCriteria = _.omitBy(object, omitIfEmpty);

            dispatch(reset('EBadgeSearchForm'));
            _.chain(criteria).keys().forEach((key: string) => {
                dispatch(change('EBadgeSearchForm', key, criteria[key]));
            }).value();

            dispatch(eBadgeQueryAction(criteria));
            dispatch(ssoUserQueryAction(criteria, caller));
        },
        unlockEBadge: (registrationCode, caller: Caller) => {
            dispatch(eBadgeUnlockAction(registrationCode, caller));
        },
        resetResult: () => {

            dispatch(reset('EBadgeSearchForm'));
            dispatch(ssoUserQuerySuccessAction([], -1));
            dispatch(eBadgeQuerySuccessAction([], -1));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryPage);



// WEBPACK FOOTER //
// ./src/containers/QueryPage.js